/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamModelDto } from '../../models/team-model-dto';

export interface UserControllerGetTeams$Params {
}

export function userControllerGetTeams(http: HttpClient, rootUrl: string, params?: UserControllerGetTeams$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TeamModelDto>>> {
  const rb = new RequestBuilder(rootUrl, userControllerGetTeams.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TeamModelDto>>;
    })
  );
}

userControllerGetTeams.PATH = '/user/teams';
